import { topologyPlugin } from './topology/topology-plugin';

export default topologyPlugin;
